module.exports = __webpack_public_path__ + "static/media/outbox.bab43aae.svg";